import { render, staticRenderFns } from "./AddonList.vue?vue&type=template&id=e038a08a&"
import script from "./AddonList.vue?vue&type=script&lang=js&"
export * from "./AddonList.vue?vue&type=script&lang=js&"
import style0 from "./AddonList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports